import { jsx as _jsx } from "react/jsx-runtime";
import Marquee from "react-fast-marquee";
import { StyledMarqueeCardsGridComponent } from "./marquee-cards-grid-component.scss";
import MarqueeProductCard from "./marquee-product-card/marquee-product-card";
const MarqueeCardsGridComponent = (props)=>{
    const { cards } = props;
    return /*#__PURE__*/ _jsx(StyledMarqueeCardsGridComponent, {
        className: "marquee-cards-grid-component",
        children: /*#__PURE__*/ _jsx(Marquee, {
            speed: 50,
            pauseOnHover: true,
            children: cards.map((card)=>{
                return /*#__PURE__*/ _jsx(MarqueeProductCard, {
                    card: card
                });
            })
        })
    });
};
export default MarqueeCardsGridComponent;
